<template>
<v-card class="py-1">
  <v-card-text class="px-0 py-2" @click="detail" style="cursor:pointer;">
    <gateway-header :data="data" :isDisconnected="isDisconnected" :optionCommands="optionCommands"></gateway-header>
    <gateway-attributes :data="data" :isDisconnected="isDisconnected" :commands="itemCommands" class="px-3 pt-1 pb-2"></gateway-attributes>
  </v-card-text>
  <gateway-menu :data="data" :optionCommands="optionCommands" @toast="val=>$emit('toast',val)" @edit="edit" style="position:absolute;top:0px;right:0px"></gateway-menu>
</v-card>
</template>

<script>
import UserAuth from '@/components/auth/UserAuth'
import GatewayItemHeader from './GatewayItemHeader'
import GatewayItemMenu from './GatewayItemMenu'
import GatewayCompactItemAttributes from './GatewayCompactItemAttributes'

export default {
  name: 'GatewayCompactItem',
  mixins: [UserAuth],
  props: ['data', 'optionCommands', 'itemCommands'],
  components: {
    'gateway-header': GatewayItemHeader,
    'gateway-menu': GatewayItemMenu,
    'gateway-attributes': GatewayCompactItemAttributes
  },
  computed: {
    isDisconnected() {
      let now = new Date().getTime();
      let diff = now - this.data.updatedTime;
      return (diff > 10 * 60 * 1000);
    }
  },
  methods: {
    detail() {
      this.$emit('detail', this.data.mac);
    },
    edit() {
      this.$emit('edit', this.data.mac);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/gateway/GatewayCompactItem.vue